<script setup lang="ts">

</script>

<template>
    <router-view/>
</template>

<style>
#app {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #F5F5F5;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

body {
    margin: 0!important;
}

nav {
    padding: 30px;
}

nav a {
    font-weight: bold;
    color: #2c3e50;
}

nav a.router-link-exact-active {
    color: #42b983;
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
    font-family: "wdzx";font-weight: 700;src: url("//at.alicdn.com/wf/webfont/O1v2jqI1iuLq/72vQ8Z8Z1pvW.woff2") format("woff2"),
url("//at.alicdn.com/wf/webfont/O1v2jqI1iuLq/iAhpO8744qSY.woff") format("woff");
    font-display: swap;
}
</style>
